import { useTranslations } from "../../lib/translations"
import { useStore } from "../../stores/store"
import { approvalsStore, totalPending } from "../../stores/approvalsStore"
import { focusAgent } from "../../stores/canvasStore"

export function NotifStrip() {
  const t = useTranslations()
  const pending = useStore(approvalsStore, totalPending)
  const byAgentId = useStore(approvalsStore, (s) => s.byAgentId)

  if (pending === 0) {
    return (
      <div className="cm-notif">
        <div className="cm-notif-empty">{t("canvas.notif.none")}</div>
      </div>
    )
  }

  const label = pending === 1
    ? t("canvas.notif.label_singular")
    : t("canvas.notif.label_plural", { count: pending })

  return (
    <div className="cm-notif">
      <div className="cm-notif-label"><span className="ping" />{label}</div>
      {Object.entries(byAgentId).map(([agentIdStr, approvals]) => {
        const agentId = Number(agentIdStr)
        const first = approvals[0]
        return (
          <div className="cm-chip" key={agentId} onClick={() => focusAgent(agentId)}>
            <b>{first.agent.name}</b>
            <span>· {first.receipt?.headline || `${approvals.length} pending`}</span>
          </div>
        )
      })}
    </div>
  )
}
